import React, {useContext, useMemo, useState, useEffect} from "react";
import { UserContext } from '../Context/UserContext';
import "../styles/hitterTrendsTable.css"
import {useNavigate} from "react-router-dom"
import PlayerTrendTeamFilter from "./PlayerTrendTeamFilter";

function GoodHitterTrendsTable({ratingTimeframe}) {
    const {state, dispatch} = useContext(UserContext);
    //console.log('state', state)
    const navigate = useNavigate()
    const [sortDirection, setSortDirection] = useState(false)
    const [sortState, setSortState] = useState("matchupRating")
    const [dataTimeframe, setDataTimeframe] = useState("ThreeYear")
    const [selectedTeam, setSelectedTeam] = useState(null)

    useEffect(() => {
        setDataTimeframe(ratingTimeframe ? "CurrentSeason" : "ThreeYear")
    }, [ratingTimeframe])
    //console.log('datatimeframe', dataTimeframe)

    const trendsByTimeFrame = state?.[`goodHitterTrends${dataTimeframe}`]
    const relDailyHitterByTimeFrame = state?.[`daily${dataTimeframe}Stats`]

    function getMatchupRating(hitID) {
        const rel_hitter = relDailyHitterByTimeFrame?.find((stat) => stat.hitter_id === hitID)
        //console.log('rel_hitter', rel_hitter)
        const matchupRatingStyles = {
            backgroundColor: (rel_hitter?.hit_matchup_rating >= 0.450 ? 'lightblue' : '') || (rel_hitter?.hit_matchup_rating >= 0.400 && rel_hitter?.hit_matchup_rating < 0.450 ? 'lightgreen' : '') || (rel_hitter?.hit_matchup_rating > 0.333 && rel_hitter?.hit_matchup_rating < 0.400 ? 'lightyellow' : '') || (rel_hitter?.hit_matchup_rating <= 0.230 ? 'lightpink' : '')
        }

        return {ratingStyle: matchupRatingStyles, rating: rel_hitter.hit_matchup_rating.toFixed(3)}
    }

    const hitterRatings = useMemo(() => {
        return trendsByTimeFrame.map((trend) => ({
            id: trend.id,
            hitterID: trend.hitter_id,
            name: trend.hitter_name,
            team: trend.team,
            matchupRating: getMatchupRating(trend.hitter_id).rating,
            numberGames: trend.num_games_sample_size,
            pctOnePlusHit: trend.pct_one_plus_hit_mr_category,
            pctTwoPlusHit: trend.pct_two_plus_hit_mr_category,
            pctTwoPlusTotalBases: trend.pct_two_plus_total_bases_mr_category,
            pctOnePlusHitsRunsRBI: trend.pct_one_plus_hits_runs_rbi_mr_category,
            pctTwoPlusHitsRunsRBI: trend.pct_two_plus_hits_runs_rbi_mr_category,
            pctThreePlusHitsRunsRBI: trend.pct_three_plus_hits_runs_rbi_mr_category,
            pctOnePlusSingle: trend.pct_one_plus_single_mr_category,
            pctOnePlusDouble: trend.pct_one_plus_double_mr_category,
            pctOnePlusHomeRun: trend.pct_one_plus_home_run_mr_category,
            pctOnePlusRun: trend.pct_one_plus_run_mr_category,
            pctOnePlusRBI: trend.pct_one_plus_rbi_mr_category,
            backgroundColor: getMatchupRating(trend.hitter_id).ratingStyle
        }));
    }, [trendsByTimeFrame])

    //console.log(hitterRatings)
    const [filteredHitters, setFilteredHitters] = useState(hitterRatings)

    useEffect(() => {
        setFilteredHitters(hitterRatings)
    }, [hitterRatings])

    function handleSort(e) {
        setSortState(e.target.dataset.sortKey)
        setSortDirection((prevDirection) => !prevDirection)
    }

    const sortedTrends = useMemo(() => {
        //if (!filteredHitterStats || !Array.isArray(filteredHitterStats)) return []
        const sortedStats = [...(filteredHitters)]?.sort((a, b) => {
            const aValue = a?.[sortState] || "";
            const bValue = b?.[sortState] || "";

            if (typeof aValue === "string" && typeof bValue === "string") {
                return sortDirection 
                    ? aValue.localeCompare(bValue)  // Ascending order for strings
                    : bValue.localeCompare(aValue); // Descending order for strings
            }

            const numA = Number(aValue) || 0;
            const numB = Number(bValue) || 0;
            return sortDirection ? numA - numB : numB - numA;
        });
        //console.log('sortedStats', sortedStats)
        //console.log('sortState', sortState)
        //console.log('sortDirection', sortDirection)
        return sortedStats;
    }, [filteredHitters, sortDirection, sortState])
    //console.log('sortedTrends', sortedTrends)

    function handleSearch(e) {
        const inputValue = e.target.value.toLowerCase('')
        if (e.target.value === "" || e.target.value === undefined || e.target.value === null) {
            setFilteredHitters(hitterRatings)
        }
        else {
            setFilteredHitters(hitterRatings.filter((rating) => rating.name.toLowerCase().includes(inputValue)))
        }
    }

    function fetchSingleHitterData(hitterID) {
        fetch(`/hitters/${hitterID}`)
            .then(res => res.json())
            .then(data => {
                if (data) {
                    dispatch({type: "fetchSingleHitter", payload: data})
                }
                else {
                    console.error("Error: Hitter data not found")
                }
            })
    }

    function navigateToHitterPage(hitterName, hitterID) {
        state.singleHitter = []
        const formattedName = hitterName.replace(/ /g, "-")
        fetchSingleHitterData(hitterID)
        navigate(`/hitter/${formattedName}`)
        window.scrollTo(0, 0)
    }

    const filteredTrends = useMemo(() => {
        if (selectedTeam === null) {
            return sortedTrends
        }
        else {
            const filteredStats = [...sortedTrends]?.filter((trend) => trend.team === selectedTeam)
            return filteredStats
        }
    }, [selectedTeam, sortedTrends])

    return (
        <div>
            <div className="searchBar">
                <label>Search A Hitter: </label>
                <input type="text" placeholder="Ex: Kyle Tucker" onChange={handleSearch}></input>
            </div>
            <PlayerTrendTeamFilter sortedTrends={sortedTrends} onSelect={setSelectedTeam} selectedTeam={selectedTeam}/>
            <br />
            <div className="hitterTrendsContainerTable">
                <table>
                    <thead>
                        <tr>
                            <th className={sortState === "name" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="name">Name<span>↕️</span></th>
                            <th className={sortState === "team" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="team">Team<span>↕️</span></th>
                            <th className={sortState === "matchupRating" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="matchupRating">Matchup Rating<span>↕️</span></th>
                            <th className={sortState === "numberGames" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="numberGames">Games<span>↕️</span></th>
                            <th className={sortState === "pctOnePlusHit" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusHit">1+ Hit<span>↕️</span></th>
                            <th className={sortState === "pctTwoPlusHit" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctTwoPlusHit">2+ Hits<span>↕️</span></th>
                            <th className={sortState === "pctTwoPlusTotalBases" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctTwoPlusTotalBases">2+ Total Bases<span>↕️</span></th>
                            <th className={sortState === "pctOnePlusHitsRunsRBI" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusHitsRunsRBI">1+ Hits Runs RBI<span>↕️</span></th>
                            <th className={sortState === "pctTwoPlusHitsRunsRBI" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctTwoPlusHitsRunsRBI">2+ Hits Runs RBI<span>↕️</span></th>
                            <th className={sortState === "pctThreePlusHitsRunsRBI" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctThreePlusHitsRunsRBI">3+ Hits Runs RBI<span>↕️</span></th>
                            <th className={sortState === "pctOnePlusSingle" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusSingle">1+ 1B<span>↕️</span></th>
                            <th className={sortState === "pctOnePlusDouble" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusDouble">1+ 2B<span>↕️</span></th>
                            <th className={sortState === "pctOnePlusHomeRun" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusHomeRun">1+ HR<span>↕️</span></th>
                            <th className={sortState === "pctOnePlusRun" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusRun">1+ Run<span>↕️</span></th>
                            <th className={sortState === "pctOnePlusRBI" ? "sorted-column" : ""} onClick={handleSort} data-sort-key="pctOnePlusRBI">1+ RBI<span>↕️</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTrends.map((trend) => {
                            const teamStyles = {backgroundColor: state.teamColors[trend.team].primary || "transparent"}
                            const one_plus_hit_styles = {
                                color: (trend?.pctOnePlusHit >= 60.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusHit <= 50.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const two_plus_hit_styles = {
                                color: (trend?.pctTwoPlusHit >= 25.00 ? 'rgba(0, 105, 0)' : (trend?.pctTwoPlusHit <= 15.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const two_plus_bases_styles = {
                                color: (trend?.pctTwoPlusTotalBases >= 50.00 ? 'rgba(0, 105, 0)' : (trend?.pctTwoPlusTotalBases <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const one_plus_hrr_styles = {
                                color: (trend?.pctOnePlusHitsRunsRBI >= 70.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusHitsRunsRBI <= 60.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const two_plus_hrr_styles = {
                                color: (trend?.pctTwoPlusHitsRunsRBI >= 50.00 ? 'rgba(0, 105, 0)' : (trend?.pctTwoPlusHitsRunsRBI <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const three_plus_hrr_styles = {
                                color: (trend?.pctThreePlusHitsRunsRBI >= 40.00 ? 'rgba(0, 105, 0)' : (trend?.pctThreePlusHitsRunsRBI <= 30.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const one_plus_single_styles = {
                                color: (trend?.pctOnePlusSingle >= 55.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusSingle <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const one_plus_double_styles = {
                                color: (trend?.pctOnePlusDouble >= 22.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusDouble <= 15.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const one_plus_hr_styles = {
                                color: (trend?.pctOnePlusHomeRun >= 20.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusHomeRun <= 10.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const one_plus_run_styles = {
                                color: (trend?.pctOnePlusRun >= 55.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusRun <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }
                            const one_plus_rbi_styles = {
                                color: (trend?.pctOnePlusRBI >= 55.00 ? 'rgba(0, 105, 0)' : (trend?.pctOnePlusRBI <= 40.00 ? 'rgba(180, 0, 0)' : 'rgba(0, 0, 0)'))
                            }

                            return (
                                <tr key={trend.id}>
                                    <td id="hitterNameTD" onClick={() => navigateToHitterPage(trend.name, trend.hitterID)}>{trend.name}</td>
                                    <td style={teamStyles}>{trend.team}</td>
                                    <td style={trend.backgroundColor}>{trend.matchupRating}</td>
                                    <td>{trend.numberGames}</td>
                                    <td style={one_plus_hit_styles}>{trend.pctOnePlusHit}%</td>
                                    <td style={two_plus_hit_styles}>{trend.pctTwoPlusHit}%</td>
                                    <td style={two_plus_bases_styles}>{trend.pctTwoPlusTotalBases}%</td>
                                    <td style={one_plus_hrr_styles}>{trend.pctOnePlusHitsRunsRBI}%</td>
                                    <td style={two_plus_hrr_styles}>{trend.pctTwoPlusHitsRunsRBI}%</td>
                                    <td style={three_plus_hrr_styles}>{trend.pctThreePlusHitsRunsRBI}%</td>
                                    <td style={one_plus_single_styles}>{trend.pctOnePlusSingle}%</td>
                                    <td style={one_plus_double_styles}>{trend.pctOnePlusDouble}%</td>
                                    <td style={one_plus_hr_styles}>{trend.pctOnePlusHomeRun}%</td>
                                    <td style={one_plus_run_styles}>{trend.pctOnePlusRun}%</td>
                                    <td style={one_plus_rbi_styles}>{trend.pctOnePlusRBI}%</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default GoodHitterTrendsTable